var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficeBuilding = function SvgOfficeBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331 421h30v91h-30zM391 421h30v91h-30zM121 451h30v61h-30zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 482H0v30h91v-91h90v91h60V151H31zm120-271h30v30h-30zm0 60h30v30h-30zm0 60h30v30h-30zM91 211h30v30H91zm0 60h30v30H91zm0 60h30v30H91zM121 0v91H61v30h150V91h-60V0zM481 0 301 61v180h-30v271h30V391h150v121h61v-30h-31zM376 331h-30v-30h30zm60 0h-30v-30h30zm0-60h-90v-30h90zm0-60h-90v-30h90zm0-60h-90v-30h90zm0 0"
  })));
};
export default SvgOfficeBuilding;